<template>
    <div class="w-full md:w-1/3 mr-xl">
        <a
            class="variant-tab h-full text-left"
            :class="{ 'is-campaign': isCampaign, 'is-active': selectedVariant === variant }"
            tabindex="0"
            @click="$emit('select', variant)"
            @keydown.enter="$emit('select', variant)"
        >
            <div v-if="isCampaign" class="campaign-badge rounded-l absolute pin-t pin-l mt-sm -ml-lg">
                {{ lang('Kampanj','Campaign') }}
            </div>

            <div>
                <div class="mt-xs text-lg xl:text-xl font-extrabold">
                    {{ productVariation }}
                </div>
                <div class="mt-sm text-sm font-bold text-neutral-dark">
                    {{ price }}
                </div>

                <div v-if="priceAfterCampaign" class="mt-xs text-xs">
                    {{ priceAfterCampaign }}
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            variant: {
                required: false,
                type: Object,
                default: null,
            },
            selectedVariant: {
                required: false,
                type: Object,
                default: null,
            },
            isCampaign: {
                required: false,
                type: Boolean,
            },
            productType: {
                required: false,
                type: String,
                default: null,
            },
            productVariation: {
                required: true,
                type: String,
            },
            price: {
                required: true,
                type: String,
            },
            priceAfterCampaign: {
                required: false,
                type: String,
                default: null,
            },
        },
    };
</script>